/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";
import { CircularProgress } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";

interface Props {
  checkedCount: number;
  isLoading: boolean;
  tags: any;
  onAlterarEtiqueta: (idEtiqueta: string) => void;
}

export const TagsMultipleContent: React.FC<Props> = ({
  checkedCount,
  isLoading,
  tags,
  onAlterarEtiqueta,
}) => (
  <div
    style={{
      padding: "28px",
      maxHeight: "550px",
      overflowY: "auto",
      fontFamily:
        "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
      position: "relative",
    }}
  >
    {isLoading && (
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(255, 255, 255, 0.95)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 1000,
          borderRadius: "8px",
          backdropFilter: "blur(2px)",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "16px",
          }}
        >
          <CircularProgress size={40} style={{ color: "#2D5BFF" }} />
          <p
            style={{
              fontSize: "14px",
              color: "#6B7280",
              fontWeight: 500,
              margin: 0,
              fontFamily: "inherit",
            }}
          >
            Aplicando etiqueta...
          </p>
        </div>
      </div>
    )}

    <div
      style={{
        marginBottom: "28px",
        paddingBottom: "20px",
        borderBottom: "2px solid #F3F4F6",
      }}
    >
      <h2
        style={{
          fontSize: "20px",
          fontWeight: 700,
          color: "#111827",
          marginBottom: "10px",
          marginTop: 0,
          fontFamily: "inherit",
          letterSpacing: "-0.02em",
        }}
      >
        Alterar Etiquetas
      </h2>
      <p
        style={{
          fontSize: "15px",
          color: "#6B7280",
          margin: 0,
          fontFamily: "inherit",
          fontWeight: 400,
        }}
      >
        {checkedCount} lead{checkedCount !== 1 ? "s" : ""} selecionado
        {checkedCount !== 1 ? "s" : ""}
      </p>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
      <div
        onClick={() => !isLoading && onAlterarEtiqueta("")}
        style={{
          display: "flex",
          alignItems: "center",
          padding: "14px 18px",
          borderRadius: "10px",
          border: "1.5px solid #E5E7EB",
          cursor: isLoading ? "not-allowed" : "pointer",
          transition: "all 0.2s ease",
          backgroundColor: "#FFFFFF",
          opacity: isLoading ? 0.6 : 1,
          boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
        }}
        onMouseEnter={(e) => {
          if (!isLoading) {
            e.currentTarget.style.backgroundColor = "#F9FAFB";
            e.currentTarget.style.borderColor = "#D1D5DB";
            e.currentTarget.style.boxShadow = "0 2px 4px 0 rgba(0, 0, 0, 0.08)";
          }
        }}
        onMouseLeave={(e) => {
          if (!isLoading) {
            e.currentTarget.style.backgroundColor = "#FFFFFF";
            e.currentTarget.style.borderColor = "#E5E7EB";
            e.currentTarget.style.boxShadow = "0 1px 2px 0 rgba(0, 0, 0, 0.05)";
          }
        }}
      >
        <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
          <div
            style={{
              width: "24px",
              height: "24px",
              borderRadius: "6px",
              border: "2.5px solid #9CA3AF",
              marginRight: "14px",
              backgroundColor: "#FFFFFF",
              flexShrink: 0,
            }}
          />
          <span
            style={{
              fontSize: "15px",
              color: "#374151",
              fontWeight: 600,
              fontFamily: "inherit",
              letterSpacing: "-0.01em",
            }}
          >
            Sem etiqueta
          </span>
        </div>
      </div>

      {tags?.etiquetasCorretor?.map(
        (item: { id: string; nome: string; cor: string }) => (
          <div
            key={item?.id}
            onClick={() => !isLoading && onAlterarEtiqueta(item?.id)}
            style={{
              display: "flex",
              alignItems: "center",
              padding: "14px 18px",
              borderRadius: "10px",
              border: "1.5px solid #E5E7EB",
              cursor: isLoading ? "not-allowed" : "pointer",
              transition: "all 0.2s ease",
              backgroundColor: "#FFFFFF",
              opacity: isLoading ? 0.6 : 1,
              boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
            }}
            onMouseEnter={(e) => {
              if (!isLoading) {
                e.currentTarget.style.backgroundColor = "#F9FAFB";
                e.currentTarget.style.borderColor = "#D1D5DB";
                e.currentTarget.style.boxShadow =
                  "0 2px 4px 0 rgba(0, 0, 0, 0.08)";
              }
            }}
            onMouseLeave={(e) => {
              if (!isLoading) {
                e.currentTarget.style.backgroundColor = "#FFFFFF";
                e.currentTarget.style.borderColor = "#E5E7EB";
                e.currentTarget.style.boxShadow =
                  "0 1px 2px 0 rgba(0, 0, 0, 0.05)";
              }
            }}
          >
            <Tooltip
              followCursor
              title={item?.nome ?? "Sem informação da etiqueta"}
              placement="top-start"
              arrow
            >
              <div
                style={{ display: "flex", alignItems: "center", width: "100%" }}
              >
                <div
                  style={{
                    width: "24px",
                    height: "24px",
                    borderRadius: "6px",
                    backgroundColor: item?.cor ?? "#9CA3AF",
                    marginRight: "14px",
                    border: "2px solid rgba(0, 0, 0, 0.08)",
                    flexShrink: 0,
                    boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.1)",
                  }}
                />
                <span
                  style={{
                    fontSize: "15px",
                    color: "#374151",
                    fontWeight: 600,
                    fontFamily: "inherit",
                    letterSpacing: "-0.01em",
                  }}
                >
                  {item?.nome}
                </span>
              </div>
            </Tooltip>
          </div>
        )
      )}
    </div>
  </div>
);
